import { ref } from 'vue'

// The Trustpilot bootstrap is loaded by the GTM container, not this app
// (P180PCM-354); poll for its global and expose a shared readiness flag.
const ready = ref(false)
let polling = false

function startPolling() {
  if (polling || globalThis.window === undefined)
    return
  polling = true

  let delay = 100
  let waited = 0
  const poll = () => {
    if ((globalThis as any).Trustpilot) {
      ready.value = true
      return
    }
    // Give up after ~20s (GTM tag not firing on this host); cookieless stays.
    if (waited >= 20000) {
      console.warn('[Trustpilot] script not detected after 20s; the GTM tag may not be firing on this host — staying on the cookieless render.')
      return
    }
    delay = Math.min(delay * 1.5, 2000)
    waited += delay
    setTimeout(poll, delay)
  }
  poll()
}

export function useTrustpilotReady() {
  startPolling()
  return { ready }
}
